import * as RadixSelect from '@radix-ui/react-select'
import { forwardRef, useContext } from 'react'
import { SelectItemPrimitive } from '../primitives/SelectItemPrimitive'
import { SelectContext } from '../SelectContext'

export interface SelectItemProps extends RadixSelect.SelectItemProps {}

export const SelectItem = forwardRef<HTMLDivElement, SelectItemProps>(
  ({ children, ...props }, ref) => {
    const { variant } = useContext(SelectContext)

    return (
      <SelectItemPrimitive {...props} variant={variant} ref={ref}>
        {children}
      </SelectItemPrimitive>
    )
  }
)
